import React from "react"
import BaseLayout from "../layouts/BaseLayout"

const DownForMaintenance = () => <BaseLayout forceDownForMaintenance />

export default DownForMaintenance
